import { z } from "zod";

import { auditEventBaseSchema } from "./audit-event-base";
import { auditEventTypeSchema } from "./audit-event-type";

const ignoredWorkMetadataSchema = z
	.object({
		LPN: z.string().optional(),
		BatchId: z.string().optional(),
		SampleInternalUniqueId: z.string().optional(),
		SampleStatus: z.string().optional(),
		BatchQuantity: z.number().optional(),
		RuleName: z.string().optional(),
		ActionType: z.string().optional(),
		Reason: z.string().optional(),
	})
	.catchall(z.unknown());

const auditEventImportIgnoredDataSchema = z.preprocess(
	(value) => {
		if (typeof value !== "object" || value === null) {
			return value;
		}

		const data = value as Record<string, unknown>;
		if ("IgnoredWorkMetadata" in data) {
			return value;
		}

		return { IgnoredWorkMetadata: value };
	},
	z.object({ IgnoredWorkMetadata: ignoredWorkMetadataSchema.optional() }).catchall(z.unknown()),
);

export const auditEventImportIgnoredSchema = auditEventBaseSchema.extend({
	auditType: z.literal(auditEventTypeSchema.enum.ImportIgnored),
	data: auditEventImportIgnoredDataSchema,
});

export type AuditEventImportIgnored = z.infer<typeof auditEventImportIgnoredSchema>;
